<template>

  <div v-if="!selectedDevice">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Current Device: <i>None selected</i></h5>
      </div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">PROPERTY</th>
          <th scope="col">VALUE</th>
        </tr>
      </thead>
      <tbody>

        <tr>
          <td><b>WURFL ID:</b></td>
          <!-- td>{{selectedDevice[capa]}}</td -->
          <td>No device profile to display yet.</td>
        </tr>
      </tbody>
    </table>
  </div>


  <div v-if="selectedDevice">
    <div class="card-body">
      <h5 class="card-title">{{ selectedDevice.capabilities.brand_name }}  {{ selectedDevice.capabilities.model_name }} <span v-if="selectedDevice.capabilities.marketing_name"> ({{selectedDevice.capabilities.marketing_name}})</span></h5>
    </div>

    <table class="md:table md:table-zebra sm:w-full">
      <thead>
        <tr>
          <th class="sm:px-2 text-xl">PROPERTY</th>
          <th class="sm:px-2 text-xl">VALUE</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="sm:px-2"><b>WURFL ID:</b></td>
          <!-- td>{{selectedDevice[capa]}}</td -->
          <td class="sm:px-2">{{breakLongIds(selectedDevice.wurfl_id)}}</td>
        </tr>
        <tr v-for="capa in listOfCapabilities" :key="capa">
          <td class="sm:px-2"><b>{{capa}}</b></td>
          <!-- td>{{selectedDevice[capa]}}</td -->
          <td class="sm:px-2">{{fieldValue(selectedDevice.capabilities,capa)}}</td>
        </tr>

        <tr v-for="capa in availableCapabilities" :key="capa">
          <td class="sm:px-2"><b>{{capa}}</b></td>
          <!-- td>{{selectedDevice[capa]}}</td -->
          <td class="sm:px-2">{{fieldValue(selectedDevice.capabilities,capa)}}</td>
        </tr>


        <tr>
          <td class="sm:px-2"><b>Images:</b></td>
          <td class="sm:px-2">[<a class="underline font-bold" :href="`https://www.google.com/search?tbm=isch&q=${encodeCompleteName(selectedDevice.capabilities)}`" target="_blank">Device Images</a>]<br/><i class="font-normal text-sm">opens Google Images in a new tab</i></td>
        </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
import {useUiElements} from "./../store/uiElements"
import { mapState } from 'pinia'


export default {

  name: 'ShowSingleDevice',

  data() {
    return {
      listOfCapabilities :[
        // 'id',
        'brand_name',
        'model_name',
        'marketing_name'
        ]
    }
  },

  computed: {
    ...mapState(useUiElements, {
        selectedDevice: "selectedDevice",
        availableCapabilities: "availableCapabilities",
    })
  },

  methods: {

    fieldValue(device, capa) {

      let str = device[capa];
      if (!str) {
        console.log(`capa ${capa} not found in device`);
        return "";
      }
      let n = 24; // max number of chars or truncate
      return (str.length > n) ? str.substr(0, n-1) + '...' : str;
    },


    encodeCompleteName(device) {

      let result = ""
      for (let i = 0; i < this.listOfCapabilities.length; i++) {
        if (device[this.listOfCapabilities[i]])  {
          result += "+"+encodeURIComponent(device[this.listOfCapabilities[i]])
        }
        // console.log(this.listOfCapabilities[i]);
      }
      return result
    },

    breakLongIds(wid) {
      let idx = wid.indexOf("_ver1")
      if ( idx == -1) {
        return wid
      }
      return wid.substr(0,idx+5) + " " + wid.substr(idx+5,wid.length)
    }

    // ...mapActions(useUiElements, ['setCurrentDevice'])
  }

}
</script>

<!-- <style scoped>
tr:hover{
  color: brown;
  cursor: pointer;
}
</style> -->